export const storyblokToken = 'j8ElXdLPpoQZnQXrUfdGfgtt'
export const defaultLanguage = 'fr'
export const alternativeLanguages = ['en', 'es', 'it', 'de', 'ja']
export const baseUrl = 'https://shoppingfeed.com'
export const relations = [
  'global-reference.reference',
  'resource-item.reference',
  'testimonial-reference.reference',
  'grid-cards-v2.cards',
]
